import { canAgentNameBeSet, isCommonAgentNameMandatory } from '../../../Functions';

export const isButtonEnabled = (team, legalUnitName) => {
  if (!team?.codePrefix?.trim()) {
    return false;
  }

  if (canAgentNameBeSet(legalUnitName)) {
    return true;
  }

  if (isCommonAgentNameMandatory(team)) {
    if (!team?.commonAgentName?.trim()) {
      return false;
    }
  }
  return true;
};
